module.exports = __webpack_public_path__ + "971efe1870421d5d93c2dcb0bade0af1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-5.png
// module id = 3140
// module chunks = 0